import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Button, Tooltip, Box, CircularProgress } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';

import { getCategoriasDoNegocio, deletarCategoria } from '../../store/actions/categoria';
import { toggleShowDialog } from '../../store/actions/dialog';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';

const Categoria = props => {
    const history = useHistory();

    const {
        negocioDoUsuario,
        categorias,
        getCategoriasDoNegocio,
        deletarCategoria,
        toggleShowDialog,
        loading
    } = props;
    const [toggleDeleteDialog, setToggleDeleteDialog] = useState(false);

    useEffect(_ => {
        getCategoriasDoNegocio(negocioDoUsuario);
    }, [getCategoriasDoNegocio, negocioDoUsuario])

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            sortable: true,
            width: '70px',
        },
        {
            name: 'Descrição',
            selector: (row) => row.nome,
            left: 'true',
            sortable: true,
        },
        {
            name: 'Prioridade',
            selector: (row) => row.prioridade,
            center: 'true',
            sortable: true,
            width: '130px',
        },
        {
            name: 'Qtd. Produtos Vinculados',
            selector: (row) => row.quantidadeProdutosVinculados,
            center: 'true',
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (
                row.ativo ? <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon> : <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            sortable: true,
            width: '100px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar Categoria' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarCategoria(row.id)}><Icon>edit</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Excluir Categoria' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="excluir" size='small' color='secondary' onClick={() => handleDeletaCategoria(row)}><Icon>delete</Icon></IconButton>
                    </Tooltip>
                </>
            ),
            width: '10%'
        }
    ];

    const handleEditarCategoria = (id) => {
        history.push({
            pathname: '/categorias/editar-categoria',
            state: {
                categoriaId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleDeletaCategoria = (row) => {
        toggleShowDialog(row);
        setToggleDeleteDialog(true);
    }

    const handleCancelarDelete = () => {
        setToggleDeleteDialog(false);
    }

    const handleConfirmarDelete = (idDialogShow) => {
        deletarCategoria(idDialogShow);
        setToggleDeleteDialog(false);
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Categorias' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={categorias}
                    visibleSearch={categorias && categorias.length > 0}
                />
                <Grid container >
                    <Button component={Link} variant='contained' color='secondary' to={{ pathname: '/categorias/cadastrar-categoria', state: { from: window.location.pathname } }}>Adicionar Categoria</Button>
                </Grid>
            </Box>
            <DialogAlert
                title='Excluir Categoria'
                okButton={true}
                okButtonClick={handleConfirmarDelete}
                cancelButtonClick={handleCancelarDelete}
                labelOkButton='Confirmar'
                cancelButton={true}
                labelCancelButton='Cancelar'
                openDialog={toggleDeleteDialog}
            >
                Tem certeza que deseja excluir a categoria?
            </DialogAlert>
        </>
    )
}

const mapStateToProps = state => ({
    categorias: state.categoria.categorias,
    idDialogShow: state.dialog.idDialogShow,
    negocioDoUsuario: state.negocio.negocioDoUsuario,
    loading: state.categoria.loading,
})
const mapDispatchToProps = dispatch => bindActionCreators({
    toggleShowDialog,
    getCategoriasDoNegocio,
    deletarCategoria,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Categoria)